<fieldset class="radio">
    <legend [ngClass]="{'blue-text': isBlueText}" class="field__label  {{labelClass}}">{{label}}</legend>
    <div class="options-container">
        <div *ngFor="let option of options">
            <input id="{{radioGroupName + '_' + option.value}}"
                   value="{{option.value}}"
                   class="option__input"
                   type="radio"
                   name="{{radioGroupName}}"
                   (click)="setValue(option)"
                   [checked]="option.value === selectedValue"
                   [disabled]="option.disabled"
                   (change)="onBlur()" />
            <label class="option" for="{{radioGroupName + '_' + option.value}}" [ngClass]="option.disabled ? 'field--disabled' : ''">{{option.htmlLabel}}</label>
            <div *ngIf="option.showHelperText">
                {{option.helperText}}
            </div>
        </div>
        <ErrorMessages [errorMessages]="errorMessages"></ErrorMessages>
    </div>
</fieldset>
